import React from 'react';

import { employerDeclarationTypes } from './actions'


const initialState = {
    isFetching: false,
}


export function employerDeclaration(state = initialState, action) {

    switch(action.type) {

        case employerDeclarationTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case employerDeclarationTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.data = action.data

            return state


        default:
            return state
    }
}